import {createAction, props} from '@ngrx/store';
import {IEnvironmentState} from '@spout/global-web/models';

export const loadEnvironment = createAction(
  '[Environment] Load Environment',
  props<{payload: IEnvironmentState}>()
);
